import type Swiper from 'swiper';
import SwiperSlider from '@/components/swiper-slider';

class SimilarFlatsSlider {
    private wrapper: HTMLElement;
    private sliderContainer: HTMLElement | null;
    private counterCurrent: HTMLElement | null;
    private prevBtn: HTMLElement | null;
    private nextBtn: HTMLElement | null;
    private sliderInstance: Swiper;

    /**
     * Инициализирует слайдер для переданного контейнера.
     * Находит все необходимые дочерние элементы и запускает Swiper.
     *
     * @param {HTMLElement} wrapper - корневой элемент слайдера (.j-similar-flats)
     */
    init(wrapper: HTMLElement): void {
        this.wrapper = wrapper;
        this.sliderContainer = this.wrapper.querySelector<HTMLElement>('.j-similar-flats__slider');
        this.counterCurrent = this.wrapper.querySelector<HTMLElement>('.j-similar-flats__counter-current');
        this.prevBtn = this.wrapper.querySelector<HTMLElement>('.j-similar-flats-slider-prev');
        this.nextBtn = this.wrapper.querySelector<HTMLElement>('.j-similar-flats-slider-next');

        if (!this.sliderContainer) {
            return;
        }

        this.initSlider();
    }

    /**
     * Создаёт экземпляр SwiperSlider с настройками адаптивности и навигацией.
     * После инициализации подключает логику счётчика.
     */
    private initSlider(): void {
        const slider = new SwiperSlider({
            item    : this.sliderContainer!,
            settings: {
                wrapperClass : 'j-similar-flats__slider-wrapper',
                slideClass   : 'j-similar-flat-card',
                speed        : 500,
                slidesPerView: 1.05,
                spaceBetween : 0,
                navigation   : {
                    nextEl: this.nextBtn,
                    prevEl: this.prevBtn
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.35
                    },
                    1280: {
                        slidesPerView: 4
                    }
                }
            }
        });

        this.sliderInstance = slider.init();
        this.initCounter();
    }

    /**
     * Устанавливает начальное значение счётчика и подписывается на событие
     * смены слайда для обновления текущего номера.
     */
    private initCounter(): void {
        if (!this.counterCurrent) {
            return;
        }

        const counterCurrent = this.counterCurrent;

        counterCurrent.innerText = '1';

        this.sliderInstance.on('slideChange', (swiper: Swiper) => {
            counterCurrent.innerText = String(swiper.realIndex + 1);
        });
    }
}

export default SimilarFlatsSlider;
